import { SaveReportPayload } from ".";
import {
  AddPartnerDetailsType,
  UpdatePartnerDetailsType,
  LinkPartnerPayloadType,
  getFilteredPartnersSagaActionPayloadType,
} from "../../slices/partner-details/Types";

export const partnerDetailsSagaActionTypes = {
  callGetAllPartnersSaga: "callGetAllPartnersSaga",
  callGetPartnerDropdownSaga: "callGetPartnerDropdownSaga",
  callGetPartnerDetailsSaga: "callGetPartnerDetailsSaga",
  callAddPartnerSaga: "callAddPartnerSaga",
  callUpdatePartnerSaga: "callUpdatePartnerSaga",
  callGetPartnerTypesSaga: "callGetPartnerTypesSaga",
  callGetRevenueStreamSaga: "callGetRevenueStreamSaga",
  callGetPartnerVerticalSaga: "callGetPartnerVerticalSaga",
  callGetPartnerTierSaga: "callGetPartnerTierSaga",
  callLinkPartnerSaga: "callLinkPartnerSaga",
  callUnlinkPartnerSaga: "callUnlinkPartnerSaga",
  callGetPartnerChildrenSaga: "callGetPartnerChildrenSaga",
  callTogglePartnerEnableSaga: "callTogglePartnerEnableSaga",
  callGetFilteredPartnersSaga: "callGetFilteredPartnersSaga",
  callDeletePartnerSaga: "callDeletePartnerSaga",
  callGetUserRolesSaga: "callGetUserRolesSaga",
  callGetJoinedTablesFieldsSaga: "callGetJoinedTablesFieldsSaga",
  callSaveReportDataSaga: "callSaveReportDataSaga",
  callExportReportSaga: "callExportReportSaga"
};

export const getAllPartnersSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetAllPartnersSaga,
  };
};

export const getPartnerDropdownSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerDropdownSaga,
  };
};

export const getPartnerDetailsSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerDetailsSaga,
    payload: {
      ID: ID,
    },
  };
};

export const addPartnerSagaAction: (partnerDetails: AddPartnerDetailsType) => {
  type: string;
  payload: {
    partnerDetails: AddPartnerDetailsType;
  };
} = (partnerDetails: AddPartnerDetailsType) => {
  return {
    type: partnerDetailsSagaActionTypes.callAddPartnerSaga,
    payload: {
      partnerDetails: partnerDetails,
    },
  };
};

export const updatePartnerSagaAction: (
  partnerDetails: UpdatePartnerDetailsType
) => {
  type: string;
  payload: {
    partnerDetails: UpdatePartnerDetailsType;
  };
} = (partnerDetails: UpdatePartnerDetailsType) => {
  return {
    type: partnerDetailsSagaActionTypes.callUpdatePartnerSaga,
    payload: {
      partnerDetails: partnerDetails,
    },
  };
};

export const getPartnerTypesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerTypesSaga,
  };
};

export const getRevenueStreamSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetRevenueStreamSaga,
  };
};

export const getPartnerVerticalSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerVerticalSaga,
  };
};

export const getPartnerTierSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerTierSaga,
  };
};

export const linkPartnerSagaAction: (payload: LinkPartnerPayloadType) => {
  type: string;
  payload: LinkPartnerPayloadType;
} = (payload: LinkPartnerPayloadType) => {
  return {
    type: partnerDetailsSagaActionTypes.callLinkPartnerSaga,
    payload: payload,
  };
};

export const unlinkPartnerSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerDetailsSagaActionTypes.callUnlinkPartnerSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getPartnerChildrenSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerDetailsSagaActionTypes.callGetPartnerChildrenSaga,
    payload: {
      ID: ID,
    },
  };
};

export const togglePartnerEnableSagaAction: (payload: {
  ID: number;
  enable: number;
}) => {
  type: string;
  payload: {
    ID: number;
    enable: number;
  };
} = (payload) => {
  return {
    type: partnerDetailsSagaActionTypes.callTogglePartnerEnableSaga,
    payload: payload,
  };
};

export const getFilteredPartnersSagaAction: (
  payload: getFilteredPartnersSagaActionPayloadType
) => {
  type: string;
  payload: getFilteredPartnersSagaActionPayloadType;
} = (payload) => {
  return {
    type: partnerDetailsSagaActionTypes.callGetFilteredPartnersSaga,
    payload: payload,
  };
};

export const deletePartnerSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: partnerDetailsSagaActionTypes.callDeletePartnerSaga,
    payload: {
      ID: ID,
    },
  };
};

// GET USER ROLES (Lookup Data)
export const getUserRolesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetUserRolesSaga,
  };
};

export const getJoinedTablesFieldsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerDetailsSagaActionTypes.callGetJoinedTablesFieldsSaga,
  };
};


export type SaveReportDataSagaActionInput = {
  payload: SaveReportPayload;
  onSuccess?: (resp: {
    report_id: number;
    mode?: "created" | "updated" | "copy_created";
  }) => void;
  onError?: (errorMessage: string) => void;

};

export const saveReportDataSagaAction: (data: SaveReportDataSagaActionInput) => {
  type: string;
  data: SaveReportDataSagaActionInput;
} = (data: any) => {
  return {
    type: partnerDetailsSagaActionTypes.callSaveReportDataSaga,
    data,
  };
};


export type ExportReportSagaActionInput = {
  reportId: number;
  userId: number;
  fileName?: string;
};


export const exportReportSagaAction: (
  payload: ExportReportSagaActionInput
) => {
  type: string;
  payload: ExportReportSagaActionInput;
} = (payload) => {
  return {
    type: partnerDetailsSagaActionTypes.callExportReportSaga,
    payload,
  };
};

